import "./MainSectionLast.css"

function MainSectionLast () {

    return (
        <>
            <section className="lastSection">
                <div className="positanoPhoto">
                    <img src="../Assets/positano.webp" alt="positano view"/>
                    <p>Foto di Sander Crombach su Unsplash.</p> 
                </div>
                
            </section>
        </>
    );
}
export default MainSectionLast;